module.exports = __webpack_public_path__ + "img/icone_corte_de_cabo.affcb4fa.png";